/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
// import initialPropertiesData from "../../properties-list.json";
import FeatureItem from "../../Components/FeatureItem";
import Pagination from "rc-pagination/lib/Pagination";
import { PROPERTIES_URL, PROPERTY_TYPE_URL } from "../../Global/API's";
import SearchInput from "../../Components/SearchInput/SearchInput";

const initialData = {
  data: [
    {
      property: {
        address: null,
        price: null,
        listingID: null,
        bedrooms: null,
        totalBaths: null,
        sqft: null,
        remarksConcat: "",
        priceData: {},
      },
      images: [
        {
          full: null,
        },
      ],
    },
  ],
};

const FeaturedListing = () => {
  const [paginationObj, setPaginationObj] = useState({
    current: 1,
    pageSize: 20,
  });
  const [propertyTypeData, setPropertyTypeData] = useState(null);
  const [propertiesData, setPropertiesData] = useState(initialData);
  const [sortedValue, setSortedValue] = useState("0");
  const [filterData, setFilterData] = useState({
    search: "",
    propertyType: "",
    sqftValue: "",
    minPrice: "",
    maxPrice: "",
    totalBeds: "",
    totalBaths: "",
  });
  const [filterResetCount, setFilterResetCount] = useState(0);

  const getPropertiesData = async (
    limit = paginationObj.pageSize,
    current = paginationObj.current
  ) => {
    const {
      propertyType,
      sqftValue,
      minPrice,
      maxPrice,
      totalBeds,
      totalBaths,
    } = filterData;

    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const url = `${PROPERTIES_URL}?limit=${limit}&page=${current}&featured=y&orderBy=${sortedValue}&propertyType=${propertyType}&sqFeet=${sqftValue}&minPrice=${minPrice}&maxPrice=${maxPrice}&minBeds=${totalBeds}&minBaths=${totalBaths}&search=${filterData.search}`;
      const response = await fetch(url, options);
      const data = await response.json();
      setPropertiesData(data);
    } catch (error) {
      console.log(error);
    }
  };

  const getPropetyTypeData = async () => {
    const response = await fetch(PROPERTY_TYPE_URL);
    const fetchedData = await response.json();
    const filterData = fetchedData.data
      .split(",")
      .filter((item) => item !== "");
    setPropertyTypeData(filterData);
  };

  useEffect(() => {
    getPropetyTypeData();
    getPropertiesData();
  }, []);

  useEffect(() => {
    onPageLoad(1, paginationObj.pageSize);
  }, [sortedValue]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const onPageLoad = (current, pageSize) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setPaginationObj({ current: current, pageSize: pageSize });
    setPropertiesData(initialData);
    getPropertiesData(pageSize, current);
  };

  const onReserFilter = () => {
    setFilterData({
      search: "",
      propertyType: "",
      sqftValue: "",
      minPrice: "",
      maxPrice: "",
      totalBeds: "",
      totalBaths: "",
    });
    setFilterResetCount((prev) => prev + 1);
  };
  useEffect(() => {
    if (filterResetCount > 0) {
      onPageLoad(1, paginationObj.pageSize);
    }
  }, [filterResetCount]);

  return (
    <section className="feature-list-main">
      <div className="container">
        <h2>Feature Listings</h2>
        <p>
          The following properties are listed with Selzer Realty. If you would
          like to review listings with an agent, click here so we can match you
          with the Realtor who can best meet your needs, or call us at the
          number listed above.
        </p>
      </div>
      <div className="container-fluid">
        <div className="feature-list">
          <div className="feature-list-right">
            <h4>Search Homes For Sale</h4>
            <div className="search-home">
              <div className="form-main">
                <label>Location Search</label>
                <form className="search-block">
                  <SearchInput
                    value={filterData.search}
                    onChange={handleChange}
                  />
                  <i className="fa fa-search" aria-hidden="true"></i>
                </form>
              </div>
              <div className="row select-list">
                <div className="col-sm-6 form-group">
                  <label>Property Type</label>
                  <div className="select-block">
                    <select
                      name="propertyType"
                      onChange={handleChange}
                      value={filterData.propertyType}
                      className="form-control"
                    >
                      <option value="">Any</option>
                      {propertyTypeData &&
                        propertyTypeData.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6 form-group">
                  <label>Square Feet</label>
                  <input
                    name="sqftValue"
                    onChange={handleChange}
                    value={filterData.sqftValue}
                    placeholder="No SqFt"
                    className="form-control"
                    type="text"
                  />
                </div>
                <div className="col-sm-6 form-group">
                  <label>Min Price</label>
                  <input
                    name="minPrice"
                    onChange={handleChange}
                    value={filterData.minPrice}
                    placeholder="No Min"
                    className="form-control"
                    type="text"
                  />
                </div>
                <div className="col-sm-6 form-group">
                  <label>Max Price</label>
                  <input
                    name="maxPrice"
                    onChange={handleChange}
                    value={filterData.maxPrice}
                    placeholder="No Max"
                    className="form-control"
                    type="text"
                  />
                </div>
                <div className="col-sm-6 form-group">
                  <label>Bedrooms</label>
                  <div className="select-block">
                    <select
                      name="totalBeds"
                      onChange={handleChange}
                      value={filterData.totalBeds}
                      className="form-control"
                    >
                      <option value="0">Any</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                </div>
                <div className="col-sm-6 form-group">
                  <label>Bathrooms</label>
                  <div className="select-block">
                    <select
                      name="totalBaths"
                      onChange={handleChange}
                      value={filterData.totalBaths}
                      className="form-control"
                    >
                      <option value="0">Any</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="row select-list">
                <div className="col-sm-6 form-group">
                  <button
                    onClick={() => {
                      onPageLoad(1, paginationObj.pageSize);
                    }}
                    type="button"
                    className="btn"
                  >
                    Submit
                  </button>
                </div>
                <div className="col-sm-6 form-group">
                  <button
                    onClick={onReserFilter}
                    type="button"
                    className="btn btn-bordered"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="feature-list-left">
            <div className="feature-top-block">
              <div className="form-group">
                <label>Sort by : </label>
                <div className="select-block">
                  <select
                    onChange={(e) => {
                      setSortedValue(e.target.value);
                    }}
                    value={sortedValue}
                    className="form-control"
                  >
                    <option value="0">Any</option>
                    <option value="1">Price (High to Low)</option>
                    <option value="2">Price (Low to High)</option>
                    <option value="3">Newest</option>
                    <option value="4">Bedrooms</option>
                    <option value="5">Bathrooms</option>
                    <option value="6">Square Feet</option>
                  </select>
                </div>
              </div>
              <p>
                <b>
                  Showing{" "}
                  {propertiesData.pagination
                    ? propertiesData.pagination.total
                    : 0}{" "}
                  Properties
                </b>
              </p>
            </div>

            {propertiesData.status === "Not Found" ? (
              <div className="no-listing-block">
                <figure>
                  <img src="../assets/images/no-properties-list.png" alt="" />
                </figure>
                <h5>Couldn't find any properties matching your search</h5>
              </div>
            ) : (
              propertiesData.data.map((eachProperty) => (
                <FeatureItem
                  key={eachProperty.property.listingID}
                  eachProperty={eachProperty}
                />
              ))
            )}
            {propertiesData.pagination?.total > paginationObj.pageSize && (
              <Pagination
                pageSize={paginationObj.pageSize}
                total={
                  propertiesData.pagination === undefined
                    ? 0
                    : propertiesData.pagination.total
                }
                showTitle={false}
                current={paginationObj.current}
                onChange={onPageLoad}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default FeaturedListing;
